export const getPersonalSelector = state => state.personal;
